module.exports = __webpack_public_path__ + "img/selectIcon.4217ed8c.svg";